import { AISummaryPanel } from "@/shared/components/ai";
import {
  useGenerateSessionSummary,
  useSessionSummary,
} from "@/shared/domain/sessions/hooks";

import { useSessionOutletContext } from "../useSessionOutletContext";

export interface SessionAISummaryProps {
  /** How often to re-read a pending summary; defaults to two seconds. */
  pendingPollRateMs?: number;
}

/** The session's Summary tab: its AI summary, generated on request. */
export function SessionAISummary({ pendingPollRateMs }: SessionAISummaryProps) {
  const { session } = useSessionOutletContext();
  const sessionId = session.session_id;
  const { data, isLoading, isError } = useSessionSummary(sessionId, {
    pendingPollRateMs,
  });
  const generate = useGenerateSessionSummary();

  return (
    <AISummaryPanel
      summary={data}
      isLoading={isLoading}
      isLoadError={isError}
      isGenerating={generate.isPending}
      isGenerateError={generate.isError}
      onGenerate={() => generate.mutate({ sessionId })}
      subject={{ type: "session", id: sessionId }}
    />
  );
}
